import { render, staticRenderFns } from "./FixingOptions.vue?vue&type=template&id=1d0e0a11&lang=pug"
import script from "./FixingOptions.vue?vue&type=script&setup=true&lang=ts"
export * from "./FixingOptions.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports